module.exports = __webpack_public_path__ + "img/xm-e40_0.prt.1ee4ee53.jpg";